import { ReactNode, createContext, useContext, useMemo, useState } from "react";

// Interfaces
import { IDataControl } from "./interfaces";

// Define the context with a default value
export const DataControlContext = createContext<IDataControl>({
	children: null,
	disabled: false,
});

const useDataControlStore = (store: { data: IDataControl; setData: (value: IDataControl) => void }) => {
	return useMemo(() => store, [store]);
};

function DataControlProvider(props: Readonly<IDataControl & { children: ReactNode }>) {
	const { children, ...values } = props ?? {};
	const [data, setData] = useState<IDataControl>(values);

	// Store build
	const store = useDataControlStore({ data, setData });

	return <DataControlContext.Provider value={store}>{children}</DataControlContext.Provider>;
}

function useDataControl() {
	const context = useContext(DataControlContext);
	if (context === undefined) {
		throw new Error("useDataControl must be used within a DataControlProvider");
	}
	return context;
}

export { DataControlProvider, useDataControl };
